<template>
    <div class="sfPanel" @click="panelClick" v-show="isShow" :style="backgroundUrl">
        <floating-menu className="sfBnt" cacheName="sfPanelBnt" :isToBody="true" :isKeyBoard="false" @click="isShow=!isShow">
            <div class="icon-box">
                <i class="iconfont" :class="isShow?'icon-a-AIdiancai-kai':'icon-a-AIdiancai-guan'"></i>
            </div>
            <span>AI点菜</span>
        </floating-menu>
    </div>
</template>

<script>
import floatingMenu from '../floatingMenu/floatingMenu.vue'

const resizeEvent={
    addResizeListener(el,fn){
        if(!el.__ro__){
            el.__ro__= new ResizeObserver(fn);
            el.__ro__.observe(el)
        }
    },
    removeResizeListener(el){
        if(el.__ro__){
            el.__ro__.unobserve(el);
        }
    }
}
export default {
    name:"sfPanel",
    components:{
        floatingMenu
    },
    data(){
        return {
            //是否显示
            isShow:true,
            base64:""
        }
    },
    computed:{
        backgroundUrl(){
            if(this.base64){
                return {
                    background:'url('+this.base64+')'
                }
            }
            return "";
        }
    },
    width:{
        isShow(){
            this.$nextTick(()=>{
                if(!this.isShow){
                    if(this._baseTime){
                        clearTimeout(this._baseTime);
                    }
                }
            })
        }
    },
    mounted(){
        resizeEvent.addResizeListener(this.$el, ()=>{
            if(this.isShow){
                this.setPanel();
            }
        });
    },
    methods:{
        /** */
        setPanel(){
            let rect=this.$el.getBoundingClientRect(); 
            console.log({x:rect.x,y:rect.y,width:rect.width,height:rect.height})
            if(rect?.width){//是否显示
                this.$webBrowser.setPanelSize({x:rect.x,y:rect.y,width:rect.width,height:rect.height}).then(data=>{
                    if(data && (data.status==0 || data.state==0)){
                        console.log("位置大小设置成功");
                    }else{
                        console.log("位置大小设置失败",data);
                    }
                })
                this.setBase64();
            }
        },
        setBase64(){
            if(this._baseTime){
                clearTimeout(this._baseTime);
            }
            this.$webBrowser.getPanelBase64().then(data=>{
                if(data){
                    if(data.status==0 || data.state==0){
                        this.base64=data.data;
                    }else{
                        console.log("base64",data);
                    }
                    if(this._baseTime){
                        clearTimeout(this._baseTime);
                    }
                    this._baseTime=setTimeout(()=>{
                        this.setBase64();
                    },180);
                }
            })
        },
        panelClick(e){
            this.$webBrowser.panelClick({x:e.layerX,y:e.layerY}).then(data=>{
                console.log("panelClick:",data)
            })
        }
    },
    unmounted(){
        resizeEvent.removeResizeListener(this.$el);
        if(this._baseTime){
            clearTimeout(this._baseTime);
        }
    }
}
</script>

<style scoped>
    .sfPanel{
        position: absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        z-index:1;
        background-color: #fff;
    }
</style>
<style lang="scss">
    .sfBnt.floatingMenu.defaultStyle{
        padding: 0;
        width: auto ;
        top: 26px;
        left: 45%;
        height: 37px;
        font-size: 14px;
        background: #fff;
        overflow: hidden;
        box-shadow:none;
        border:1px solid #487BB2;
        border-radius: 4px;
        display: flex;
        align-items: center;
        box-shadow:2px 2px 5px 1px rgba(0,0,0,0.3);

        .icon-box{
            height:35px;
            display: inline-block;
            text-align: center;
            width: 35px;
            background-color:#487BB2;
            color: #fff;
            font-size: 16px;
            line-height: 35px;
        }

        span{
            padding: 0 5px;
            color: #000;
            font-weight: bold;
        }
    }
</style>